<table class="stamp-list" mat-table [dataSource]="dataSource" multiTemplateDataRows>
	<ng-container matColumnDef="activity">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.administration.shift-approval.table.timestamps-table.worktask' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			@if (element !== timeStampBeingEdited || isOfftask(element.worktask)) {
				<div>({{ element.worktask?.alias ?? '' }}) {{ element.worktask?.name ?? '' }}</div>
			} @else {
				<app-worktask-select
					[disabled]="!hasUpdateAndCreatePermission"
					[(value)]="editTask.worktaskId"
					[worktasks]="worktasks"
					[excludeOfftask]="true"
					[placeholder]="'mes.administration.shift-approval.table.timestamps-table.choose-worktask' | translate"
					[filterPlaceholder]="'mes.administration.shift-approval.create-shift-note.worktask.filter-placeholder' | translate"></app-worktask-select>
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="activity-input">
		<th mat-header-cell *matHeaderCellDef>
			<app-worktask-select
				[(value)]="newTask.worktaskId"
				[worktasks]="worktasks"
				[disabled]="timeStampBeingEdited || approved || !hasUpdateAndCreatePermission"
				[placeholder]="'mes.administration.shift-approval.table.timestamps-table.choose-worktask' | translate"
				[filterPlaceholder]="'mes.administration.shift-approval.create-shift-note.worktask.filter-placeholder' | translate"></app-worktask-select>
		</th>
	</ng-container>

	<ng-container matColumnDef="startTime">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.administration.shift-approval.table.timestamps-table.start' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			@if (element !== timeStampBeingEdited) {
				<div>{{ element.dateTimeOffset | date: 'H:mm' }}</div>
			} @else {
				<input matInput type="time" step="60" [ngClass]="{ 'start-time-error': startTimeError }" [(ngModel)]="editTask.startTime" (change)="isNewStartTimeValid(element)" [disabled]="!hasUpdateAndCreatePermission" />
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="startTime-input">
		<th mat-header-cell *matHeaderCellDef>
			<input matInput type="time" step="60" [(ngModel)]="newTask.startTime" [disabled]="timeStampBeingEdited || approved || !hasUpdateAndCreatePermission" />
		</th>
	</ng-container>

	<ng-container matColumnDef="endTime">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'mes.administration.shift-approval.table.timestamps-table.end' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ element.nextTimeStamp?.dateTimeOffset ?? '' | date: 'H:mm' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="endTime-input">
		<th mat-header-cell *matHeaderCellDef>
			<input matInput type="time" step="60" [(ngModel)]="newTask.endTime" [disabled]="timeStampBeingEdited || approved || !hasUpdateAndCreatePermission" />
		</th>
	</ng-container>

	<ng-container matColumnDef="commands">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let element">
			@if (element !== timeStampBeingEdited) {
				<div class="half-size-field inline-field">
					<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.edit-timestamp' | translate" (click)="editTimeStamp(element)" [disabled]="timeStampBeingEdited || approved || !hasUpdateAndCreatePermission">
						<mat-icon mat-list-icon svgIcon="acies_edit"></mat-icon>
					</button>
					@if (!isOfftask(element.worktask)) {
						<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.remove-timestamp' | translate" (click)="removeTimeStamp(element)" [disabled]="timeStampBeingEdited || approved || !hasUpdateOrDeletePermission">
							<mat-icon mat-list-icon svgIcon="acies_delete"></mat-icon>
						</button>
					}
					@if (isAutoAdded(element)) {
						<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.acknowledge-auto' | translate" (click)="acknowledgeAutoAdded(element)" [disabled]="timeStampBeingEdited || approved || !hasUpdatePermission" class="auto-added-btn">
							<mat-icon>check_circle_outline</mat-icon>
						</button>
					}
				</div>
			}
			@if (element === timeStampBeingEdited) {
				<div class="half-size-field inline-field">
					<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.save-changes' | translate" (click)="saveTimeStamp(element)" [disabled]="startTimeError">
						<mat-icon mat-list-icon svgIcon="acies_true"></mat-icon>
					</button>
					<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.cancel-changes' | translate" (click)="stopEditTimeStamp()">
						<mat-icon mat-list-icon svgIcon="acies_false"></mat-icon>
					</button>
				</div>
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="commands-input">
		<th mat-header-cell *matHeaderCellDef>
			<div class="half-size-field inline-field">
				<button mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.add-timestamp' | translate" (click)="addWorktask()" [disabled]="isNewValid() || !hasUpdateAndCreatePermission">
					<mat-icon svgIcon="acies_add"></mat-icon>
				</button>
			</div>
		</th>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-header-row *matHeaderRowDef="inputColumns"></tr>
	<tr class="inner-data-row" mat-row *matRowDef="let element; columns: displayedColumns"></tr>
</table>
